import { MetricCell } from "components/designV2/metricCell/metricCell";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PayoutDetails, PayoutType } from "model/Salary";
import { formatTimePeriod } from "./individualSalary.component";
import { PayoutRowGrid, SectionContainer } from "./payoutDetailRow.styled";

type Props = {
  payoutDetails: PayoutDetails[];
  currency: string;
};

export const PayoutDetailRow: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  const getPayoutTypeText = useCallback(
    (type: string): string => {
      if (type === PayoutType.Monthly) {
        return t("Salary.Monthly");
      } else if (type === PayoutType.SimflexityPayMonthly) {
        return t("Salary.SimflexityPayMonthly");
      } else if (type === PayoutType.MonthlyPerHour) {
        return t("Salary.MonthlyPerHour");
      } else {
        return t("Salary.SimflexityPayAdvance");
      }
    },
    [t],
  );

  const renderPayoutRow = useCallback(
    (payDetail: PayoutDetails, index: number, total: number) => {
      const isLastRow = index === total - 1;
      return (
        <PayoutRowGrid
          $isLastRow={isLastRow}
          key={`payout-${payDetail.period}-${index}`}
        >
          <MetricCell
            value={getPayoutTypeText(payDetail.description)}
            label={t("Salary.Type")}
          />
          <MetricCell
            value={formatTimePeriod(payDetail.period)}
            label={t("Salary.Period")}
          />
          <MetricCell
            value={`${payDetail.grossPayoutAmount} ${props.currency}`}
            label={t("Salary.GrossPayoutAmount")}
          />
          <MetricCell
            value={`${payDetail.employerTaxAmount} ${props.currency}`}
            label={t("Salary.EmployerTax")}
          />
          <MetricCell
            value={`${payDetail.workerTaxAmount} ${props.currency}`}
            label={t("Salary.Tax")}
          />
        </PayoutRowGrid>
      );
    },
    [t, props.currency, getPayoutTypeText],
  );

  if (!props.payoutDetails || props.payoutDetails.length === 0) {
    return null;
  }

  return (
    <SectionContainer>
      <Text typography="h5" color={ColorV2.Blue1}>
        {t("Salary.PayoutDetails")}
      </Text>
      {props.payoutDetails.map((payDetail, index) =>
        renderPayoutRow(payDetail, index, props.payoutDetails.length),
      )}
    </SectionContainer>
  );
};
